import type { Translation } from '../i18n-types';

const ru: Translation = {
  userGuide: 'Руководство пользователя',
  privacyPolicy: 'Политика конфиденциальности',
  termsConditions: 'Условия и положения',
  support: 'Поддержка',
  abandoned: 'Заброшено',
  completed: 'Завершено',
  cancelled: 'Отменено',
  ended: 'Завершено',
  actionComments: 'Комментарии к действиям',
  actionItem: 'Пункт действия',
  actionItemPlaceholder: 'Пункт действия...',
  actionItems: 'Пункты действий',
  actionPhaseDescription: 'Добавьте пункты действий, вы больше не можете группировать или голосовать за комментарии',
  actions: 'Действия',
  activate: 'Активировать',
  active: 'Активно',
  activeRetros: 'Активные ретроспективы',
  activeRetroUsers: 'Активные пользователи ретро',
  activeStoryboards: 'Активные сториборды',
  activeStoryboardUsers: 'Активные пользователи сториборда',
  addComment: 'Добавить комментарий',
  addPersona: 'Добавить персону',
  admin: 'Админ',
  adminCleanOldRetros: 'Очистить ретро старше {daysOld} дней',
  adminCleanOldStoryboards: 'Очистить сториборды старше {daysOld} дней',
  adminPageAdmin: 'Админ',
  adminPageAlerts: 'Оповещения',
  adminPageApi: 'API ключи',
  adminPageOrganizations: 'Организации',
  adminPageTeams: 'Команды',
  adminPageUsers: 'Пользователи',
  adminPageSubscriptions: 'Подписки',
  deleteSubscriptionConfirmation: 'Вы уверены, что хотите удалить эту подписку?',
  deleteSubscription: 'Удалить подписку',
  alertAllowDismiss: 'Разрешить отклонение',
  alertContent: 'Содержание оповещения',
  alertContentPlaceholder: 'Введите содержание оповещения',
  alertCreate: 'Создать оповещение',
  alertDelete: 'Удалить оповещение',
  alertDeleteConfirmation: 'Вы уверены, что хотите удалить это оповещение?',
  alertNamePlaceholder: 'Введите название оповещения',
  alertRegisteredOnly: 'Только зарегистрированные',
  alerts: 'Оповещения',
  alertSave: 'Сохранить оповещение',
  alertTypePlaceholder: 'Выберите тип оповещения',
  allVotesIn: 'Все голоса получены',
  apiDocumentation: 'Документация API',
  apikeyCopyFailure: 'Не удалось скопировать API ключ в буфер обмена',
  apikeyCopySuccess: 'API ключ скопирован в буфер обмена',
  apiKeys: 'API ключи',
  applicationStatsError: 'Ошибка получения статистики приложения',
  appName: 'Thunderweb',
  appPreviewAlt: 'Превью Thunderdome, интерфейс Agile Planning Poker',
  appSubtitle: 'Открытое приложение Agile Planning Poker',
  appVersion: 'Версия {version}',
  associateTeam: 'Associate Team',
  authError: 'Error encountered attempting to authenticate user',
  autoFinishVoting: 'Auto Finish Voting',
  avatarAltText: 'Placeholder Avatar',
  back: 'Back',
  battleAbandon: 'Покинуть игру',
  battleCreate: 'Создать игру',
  battleDelete: 'Удалить игру',
  battleEdit: 'Редактировать игру',
  battleEditPointsDisabled: 'Нельзя менять карточки пока активно голосование.',
  battleJoin: 'Join Game',
  battleName: 'Название игры',
  battleRemoveError: 'Error attempting to remove game.',
  battleRemoveSuccess: 'Game removed successfully.',
  battles: 'Games',
  battlesActive: 'Active Games',
  battlesActiveUsers: 'Active Game Users',
  becomeFacilitator: 'Become Facilitator',
  becomeParticipant: 'Become Participant',
  becomeSpectator: 'Become Spectator',
  blocked: 'Blocked',
  blockers: 'Blockers',
  blockersPlaceholder: "I'm blocked by...",
  brainstorm: 'Brainstorm',
  brainstormPhaseDescription: 'Add your comments below',
  brainstormPhaseFeedbackVisibility: 'Brainstorm Phase Feedback Visibility',
  brainstormVisibilityLabelConcealed: 'Feedback Concealed',
  brainstormVisibilityLabelHidden: 'Feedback Hidden',
  brainstormVisibilityLabelVisible: 'Feedback Visible',
  cancel: 'Cancel',
  cannotBeUndone: 'This cannot be undone.',
  checkIn: 'Check In',
  checkinCommentDeleteError: 'Error deleting check in comment',
  checkinCommentError: 'Error commenting on check in',
  checkinError: 'Error checking in',
  checkinMeetYesterdayGoalsQuestion: "Did you meet yesterday's goals?",
  checkins: 'Checkins',
  colorLegend: 'Color Legend',
  colorLegendNotSpecified: 'legend not specified',
  comment: 'Comment',
  comments: 'Comments',
  conciseVotingResults: 'Concise Voting Results',
  confirmDeleteRetro: 'Are you sure you want to delete this retrospective?',
  createAccount: 'Создать профиль',
  createAccountTagline: `Don't have an account?`,
  createAlertError: 'Error encountered creating alert',
  createAlertSuccess: 'Alert created successfully',
  createARetro: 'Create a Retro',
  createAStoryboard: 'Create a Storyboard',
  createBattleError: 'Ошибка создания игры',
  createOrgError: 'Error attempting to create organization',
  createRetro: 'Create Retro',
  createRetroErrorMessage: 'Error encountered creating retro',
  createStoryboard: 'Create Storyboard',
  createUserError: 'Error encountered creating user',
  customizableBattleOptions: 'Customizable Game Options',
  dateCreated: 'Created Date',
  dateUpdated: 'Updated Date',
  delete: 'Удалить',
  deleteActionItemError: 'Error deleting action item',
  deleteActionItemSuccess: 'Action item deleted successfully',
  deleteAlertError: 'Error attempting to delete alert',
  deleteAlertSuccess: 'Alert deleted successfully',
  deleteBattle: 'Delete Game',
  deleteBattleConfirmText: 'Are you sure you want to delete this game?',
  deleteBattleError: 'error deleting game',
  deleteCheckinError: 'Error deleting check in',
  deleteDepartment: 'Delete Department',
  deleteDepartmentConfirmText: 'Are you sure you want to delete this department?',
  deleteOrganization: 'Delete Organization',
  deleteOrganizationConfirmText: 'Are you sure you want to delete this organization?',
  deleteRetro: 'Delete Retro',
  deleteRetroErrorMessage: 'error deleting retro',
  deleteStoryboard: 'Delete Storyboard',
  deleteStoryboardErrorMessage: 'error deleting storyboard',
  deleteTeam: 'Delete Team',
  deleteTeamConfirmText: 'Are you sure you want to delete this team?',
  deleteUserError: 'Error encountered deleting user',
  demote: 'Demote',
  demoteUserError: 'Error encountered demoting user',
  department: 'Department',
  departmentCreate: 'Create Department',
  departmentCreateError: 'Error attempting to create department',
  departmentDeleteError: 'Error attempting to delete department',
  departmentDeleteSuccess: 'Department deleted successfully.',
  departmentGetError: 'Error getting department',
  departmentName: 'Department Name',
  departmentNamePlaceholder: 'Enter an department name',
  departments: 'Departments',
  departmentSave: 'Save Department',
  departmentTeamsGetError: 'Error getting department teams',
  departmentUsersGetError: 'Error getting department users',
  discuss: 'Discuss',
  discussPlaceholder: 'I would like to discuss...',
  done: 'Done',
  duplicateRetroSession: 'Duplicate retro session exists for your ID',
  duplicateStoryboardSession: 'Duplicate storyboard session exists for your ID',
  edit: 'Редактировать',
  editColorLegend: 'Edit Legend',
  editRetro: 'Edit Retro',
  editStoryboard: 'Edit Storyboard',
  email: 'Email',
  enterPasscode: 'Enter passcode...',
  enterYourEmail: 'Enter your email',
  execute: 'Execute',
  export: 'Export',
  facilitator: 'Facilitator',
  facilitatorCode: 'Facilitator Code',
  facilitatorCodeOptional: 'Facilitator Code (Optional)',
  facilitatorCodePlaceholder: 'Enter an optional facilitator code',
  finalPoints: 'Итого голосов',
  flag: 'Flag',
  footerAuthoredBy: 'Создано с ❤️ {authorOpen}Steven Weathers{authorClose}',
  forgotPassword: 'Forgot Your Password?',
  forgotPasswordSubtext: `Don't fret! Just enter your email and we will send you instructions to reset your password.`,
  returnToLogin: 'Return to Login',
  getAlertsError: 'Error getting alerts',
  getApikeysError: 'Error getting apikeys',
  getBattleError: 'Error getting game',
  getBattlesError: 'Error getting games',
  getCheckinsError: "Error getting check in's",
  getOrganizationsError: 'Error getting organizations',
  getRetroErrorMessage: 'error getting retro',
  getRetrosErrorMessage: 'error getting retros',
  getStoryboardErrorMessage: 'error getting storyboard',
  getStoryboardsErrorMessage: 'error getting storyboards',
  getTeamsError: 'Error getting teams',
  getUserError: 'Error getting user',
  getUsersError: 'Error getting users',
  goalsMet: 'Goals Met',
  goalsNotMet: 'Цели не достигнуты',
  group: 'Group',
  groupName: 'Group Name',
  groupPhaseDescription: 'Drag and drop comments to group them together',
  hostedDesc: '{linkOpen}Thunderdome.dev{linkClose} is a free hosted service (SaaS) without Ads.',
  hostedOrSelfHosted: 'Hosted service or self-hosted',
  importCsv: 'Import stories from a CSV file',
  importCsvFileBadFileTypeError: 'Error bad file type',
  importCsvFileReadFileError: 'Error reading file',
  importJiraXML: 'Import stories from Jira XML',
  importJiraXMLBadFileTypeError: 'Error bad file type',
  importJiraXMLReadFileError: 'Error reading file',
  incorrectPassCode: 'Incorrect passcode',
  inviteLinkCopyFailure: "Couldn't copy invite link to clipboard",
  inviteLinkCopySuccess: 'Invite Link copied to clipboard',
  jiraXmlImport: 'Jira XML Import',
  joinCodeCopyFailure: "Couldn't copy passcode to clipboard",
  joinCodeCopySuccess: 'Passcode copied to clipboard',
  joinCodeLabelOptional: 'Join Code (Optional)',
  joinCodePlaceholder: 'Enter a join code',
  joinRetro: 'Join Retro',
  joinStoryboard: 'Join Storyboard',
  joinStoryboardError: 'Error joining storyboard, refresh and try again.',
  landingCountries: 'Users in over {count} countries',
  landingFeatureOpenSourceText:
    'Check out the {repoOpen}Github repository{repoClose} to request or contribute enhancements, locale translations and bug fixes or to {donateOpen}Donate{donateClose}.',
  landingFeatureOpenSourceTitle: 'Open Source',
  landingSalesPitch:
    'Remote team collaboration with agile story pointing, sprint retrospective, story mapping and async team check-in.',
  landingTitle: 'Thunderdome is an Agile Planning Poker app',
  lastActive: 'Last Active',
  leaveRetro: 'Leave Retro',
  leaveStoryboard: 'Leave Storyboard',
  legendRetroPlaceholder: 'Enter a color legend',
  loadingRetro: 'Loading Retro...',
  loadingStoryboard: 'Loading Storyboard...',
  login: 'Войти',
  loginForRetro: 'or {loginOpen}Login{loginClose} to join the Retro',
  loginForStoryboard: 'or {loginOpen}Login{loginClose} to join the Storyboard',
  logout: 'Выйти',
  logoutError: 'Error encountered attempting to logout user',
  makeFacilitator: 'Make Facilitator',
  mfa2faLabel: '2FA/MFA Auth',
  mfa2faRemove: 'Remove 2FA/MFA',
  mfa2faRemoveFailure: 'Failed to remove 2FA/MFA',
  mfa2faRemoveSuccess: '2FA/MFA successfully removed',
  mfa2faRemoveText: 'Are you sure you want to remove 2FA/MFA?',
  mfa2faSetup: 'Setup 2FA/MFA',
  mfaAuthError: 'Error validating authenticator token',
  mfaConfirmToken: 'Confirm Token',
  mfaGenerateFailed: 'failed to start 2FA/MFA setup',
  mfaSecretKeyLabel: 'Secret Key',
  mfaSetupFailed: 'failed to validate 2FA/MFA setup token',
  mfaSetupIntro:
    'Scan the following QR code with an Authenticator Application (such as Google Authenticator or Authy) and enter the generated token.',
  mfaSetupSuccess: 'successfully enabled 2FA/MFA',
  mfaTokenLabel: 'Authenticator Token',
  mfaTokenPlaceholder: 'Enter token from authenticator app',
  myRetros: 'My Retros',
  myStoryboards: 'My Storyboards',
  name: 'Name',
  needsImprovement: 'Needs Improvement',
  nextPhase: 'Next Phase',
  noComments: 'No comments...',
  oldBattleCleanError: 'Error encountered cleaning games',
  oldGuestsCleanError: 'Error encountered cleaning guests',
  oldRetrosCleanError: 'Error encountered cleaning retros',
  oldStoryboardsCleanError: 'Error encountered cleaning storyboards',
  openSource: 'Open Source',
  optional: '(Optional)',
  optionalLeadercodePlaceholder: 'Optional leader code to become a leader',
  optionalPasscodePlaceholder: 'Optional passcode to join',
  organization: 'Organization',
  organizationCreate: 'Create Organization',
  organizationDeleteError: 'Error attempting to delete organization',
  organizationDeleteSuccess: 'Organization deleted successfully.',
  organizationGetDepartmentsError: 'Error getting organization departments',
  organizationGetError: 'Error getting organization',
  organizationGetTeamsError: 'Error getting organization teams',
  organizationGetUsersError: 'Error getting organization users',
  organizationName: 'Organization Name',
  organizationNamePlaceholder: 'Enter an organization name',
  organizations: 'Organizations',
  organizationsAndTeams: 'Organizations and Teams',
  organizationSave: 'Save Organization',
  owner: 'Owner',
  participation: 'Participation',
  passCode: 'Passcode',
  passCodeRequired: 'Passcode required to join',
  personas: 'Personas',
  planAcceptanceCriteria: 'Критерии выполнения',
  planAcceptanceCriteriaPlaceholder: 'Введите критерии выполнения задачи',
  planAdd: 'Add Stories',
  planDescription: 'Описание',
  planDescriptionPlaceholder: 'Введите описание',
  planLink: 'Ссылка',
  planLinkInvalid: "Link isn't a valid absolute URL, e.g. includes protocol (HTTP/HTTPS)",
  planLinkPlaceholder: 'Enter a link to story',
  planName: 'Story Name',
  planNamePlaceholder: 'Enter a story name',
  planPriority: 'Priority',
  planPriorityBlocker: 'Blocker',
  planPriorityHigh: 'High',
  planPriorityHighest: 'Highest',
  planPriorityLow: 'Low',
  planPriorityLowest: 'Lowest',
  planPriorityMedium: 'Medium',
  planPriorityPlaceholder: 'Select a priority',
  planReferenceId: 'ID ссылки',
  planReferenceIdPlaceholder: 'Введите ID ссылки',
  plans: 'Stories',
  planSkip: 'Skip Story',
  planType: 'Story Type',
  planTypeBug: 'ошибка',
  planTypeEpic: 'эпик',
  planTypePlaceholder: 'Типы задач',
  planTypeSpike: 'spike',
  planTypeStory: 'история',
  planTypeSubtask: 'подзадача',
  planTypeTask: 'задача',
  pointAverageRounding: 'Point Average Rounding',
  pointed: 'Оцененные ({count})',
  points: 'Голоса',
  pointValuesAllowed: 'Point Values Allowed',
  postComment: 'Post Comment',
  primeDirective: 'Prime Directive',
  promote: 'Сделать боссом',
  promoteUserError: 'Error encountered promoting user',
  questions: 'Questions',
  register: 'Register',
  reloadingRetro: 'Oops, reloading Retro...',
  reloadingStoryboard: 'Oops, reloading Storyboard...',
  remove: 'Remove',
  removeBattle: 'Remove Game',
  removeBattleConfirmText: 'Are you sure you want to remove this game?',
  removeRetro: 'Remove Retro',
  removeRetroConfirmText: 'Are you sure you want to remove this retro?',
  removeStoryboard: 'Remove Storyboard',
  removeStoryboardConfirmText: 'Are you sure you want to remove this storyboard?',
  removeUser: 'Remove User',
  removeUserConfirmText: 'Are you sure you want to remove this user?',
  requestVerifyEmail: 'Request Verification Email',
  requestVerifyEmailFailure: 'Error attempting to send Verification Email',
  requestVerifyEmailSuccess: 'Verification Email requested, watch your inbox',
  retro: 'Retro',
  retroActionCommentAddError: 'error adding retro action comment',
  retroActionCommentDeleteError: 'error deleting retro action comment',
  retroActionCommentEditError: 'error editing retro action comment',
  retroActionItems: 'Retro Action Items',
  retroAddError: 'Error attempting to add retro.',
  retroAddSuccess: 'Retro added successfully.',
  retroDeleted: 'Retro deleted',
  retroFeedbackConcealed: 'Feedback Concealed',
  retroFeedbackHidden: 'Feedback Hidden',
  retroImprovePlaceholder: 'What needs improvement...',
  retroItems: 'Retro Items',
  retroJoinError: 'Error joining retro, refresh and try again.',
  retroMaxVotesPerUserLabel: 'Max Group Votes (per User)',
  retroName: 'Retro Name',
  retroNamePlaceholder: 'Enter a retro name',
  retroQuestionPlaceholder: 'I want to ask...',
  retroRemoveError: 'Error attempting to remove retro.',
  retroRemoveSuccess: 'Retro removed successfully.',
  retros: 'Retros',
  retroWorkedPlaceholder: 'What worked well...',
  role: 'Role',
  rolePlaceholder: 'Select users role',
  save: 'Сохранить',
  search: 'Search',
  searchLengthError: 'Search value must be at least 3 characters',
  selectTeam: 'Select a Team',
  selfHostedDesc: 'Alternatively you can {linkOpen}run it on your own server{linkClose}.',
  sessionDuplicate: 'Duplicate game session exists for your ID',
  showActiveBattles: 'Show Active Games',
  showActiveRetros: 'Show active retros',
  showActiveStoryboards: 'Show active storyboards',
  showBlockedCheckins: 'Show only checkins requiring discussion',
  showCompletedActionItems: 'Show Completed Action Items',
  showVoters: 'Показать проголосовавших',
  skipped: 'Skipped',
  spectator: 'Spectator',
  storyboard: 'Storyboard',
  storyboardAddColumn: 'Add Column',
  storyboardAddError: 'Error attempting to add storyboard.',
  storyboardAddGoal: 'Add Goal',
  storyboardAddStoryToColumn: 'Add Story to Column',
  storyboardAddSuccess: 'Storyboard added successfully.',
  storyboardColumns: 'Storyboard Columns',
  storyboardDeleted: 'Storyboard deleted',
  storyboardEditColumn: 'Edit Column',
  storyboardGoalName: 'Goal name',
  storyboardGoalNamePlaceholder: 'Enter a goal name',
  storyboardGoals: 'Storyboard Goals',
  storyboardPersonas: 'Storyboard Personas',
  storyboardRemoveError: 'Error attempting to remove storyboard.',
  storyboardRemoveSuccess: 'Storyboard removed successfully.',
  storyboards: 'Storyboards',
  storyboardStories: 'Storyboard Stories',
  columnPersonasTitle: 'Column Personas',
  columnPersonasEmpty: 'No personas added to this column',
  availablePersonas: 'Available Personas',
  availablePersonasEmpty: 'No personas available',
  allPersonasAdded: 'All personas have been added to this column',
  team: 'Team',
  teamCheckins: 'Team Checkins',
  teamCreate: 'Create Team',
  teamCreateError: 'Error attempting to create team.',
  teamCreateSuccess: 'Team created successfully.',
  teamDeleteError: 'Error attempting to delete team',
  teamDeleteSuccess: 'Team deleted successfully.',
  teamGetBattlesError: 'Error getting team games',
  teamGetError: 'Error getting team',
  teamGetRetroActionsError: 'error getting retro actions',
  teamGetRetrosError: 'Error getting team retros',
  teamGetStoryboardsError: 'Error getting team storyboards',
  teamGetUsersError: 'Error getting team users',
  teamName: 'Team Name',
  teamNamePlaceholder: 'Enter an team name',
  teams: 'Teams',
  teamSave: 'Save Team',
  teamUserRequiredToCheckin: 'User must be in team to check in',
  teamUserRequiredToComment: 'User must be in team to comment',
  today: 'Today',
  todayPlaceholder: 'Today I will...',
  totalPoints: 'Total',
  totalVotes: 'Total Votes',
  type: 'Type',
  unknownWarrior: 'Unknown Player',
  unpointed: 'Неоцененные ({count})',
  updateActionItemError: 'Error updating action item',
  updateActionItemSuccess: 'Action item updated successfully',
  updateAlertError: 'Error encountered updating alert',
  updateAlertSuccess: 'Alert updating successfully',
  updateCheckinError: 'Error updating check in',
  updateComment: 'Update Comment',
  userAdd: 'Add User',
  userAddError: 'Error attempting to add user.',
  userAddSuccess: 'User added successfully.',
  userEmail: 'User Email',
  userEmailPlaceholder: 'Enter the users email',
  userName: 'User Name',
  userRemoveError: 'Error attempting to remove user.',
  userRemoveSuccess: 'User removed successfully.',
  users: 'Users',
  verifyAccount: 'Verify Account',
  verifyAccountFailedError: 'Произошла ошибка верификации.',
  verifyAccountFailedTitle: 'Верификация завершилась ошибкой',
  verifyAccountLoading: 'Подтверждение профиля...',
  verifyAccountVerifiedThanks: 'Спасибо за подтверждение почты.',
  verifyAccountVerifiedTitle: 'Профиль подтвержден',
  view: 'Посмотреть',
  vote: 'Vote',
  voteCount: 'Vote Count',
  votePhaseDescription: "Vote for the groups you'd like to discuss most",
  voteResultsAverage: 'Среднее',
  voteResultsHighest: 'Лучшее',
  votingFinish: 'Закончить голосование',
  votingLocked: 'Voting Locked',
  votingRestart: 'Перезапустить голосование',
  warriorCreate: 'Create User',
  warriorInvite: 'Invite a Player',
  warriorNudge: 'Пнуть',
  works: 'Works',
  writeCommentPlaceholder: 'Write a comment...',
  yesterday: 'Yesterday',
  yesterdayPlaceholder: 'Yesterday I...',
  yourRetros: 'Your Retros',
  yourStoryboards: 'Your Storyboards',
  addPlan: 'Add Story',
  battleNamePlaceholder: 'Введите название игры',
  autoFinishVotingLabel: 'Auto Finish Voting when all Players have voted',
  averageRoundingOptions: {
    ceil: 'Ceil',
    floor: 'Floor',
    round: 'Round',
  },
  apiKeyCreateButton: 'Create API Key',
  apiKeyPrefix: 'Key Prefix',
  lastUpdated: 'Last Updated',
  apiKeysErrorRetrieving: 'Failed to get API keys',
  apiKeyDeleteSuccess: 'API Key deleted',
  apiKeyDeleteFailed: 'Failed to delete API Key',
  apiKeyUpdateSuccess: 'API Key updated',
  apiKeyUpdateFailed: 'Failed to update API Key',
  deactivate: 'Deactivate',
  profileErrorRetrieving: 'Error getting your profile',
  profileErrorUpdating: 'Error encountered updating your profile',
  profileUpdateSuccess: 'Profile updated',
  passwordUpdated: 'Password updated.',
  passwordUpdateError: 'Error encountered attempting to update password',
  profileDeleteError: 'Error encountered attempting to delete your account.',
  profileTitle: 'Your Profile',
  profile: 'Profile',
  updatePassword: 'Update Password',
  deleteAccount: 'Delete Account',
  deleteAccountWarningStatement: 'Are you sure you want to delete your account?',
  deleteConfirmButton: 'Confirm Delete',
  apiKeyNameInvalid: 'Please enter a key name',
  apiKeyCreateSuccess: 'New Api Key {keyName} created and {onlyNowOpen}it will be displayed only now{onlyNowClose}',
  apiKeyStoreWarning:
    'Please store it somewhere safe because as soon as you navigate away from this page, we will not be able to retrieve or restore this generated token.',
  apiKeyLimitReached: 'You have the max number of API keys allowed.',
  apiKeyUnverifiedUser: 'Only verified registered users can create API keys.',
  apiKeyCreateFailed: 'Failed to create API Key',
  apiKeyName: 'Key Name',
  apiKeyNamePlaceholder: 'Enter a Key Name',
  create: 'Create',
  close: 'Close',
  country: 'Country',
  company: 'Company',
  verified: 'Подтвержден',
  registeredUsers: 'Registered Users',
  myBattles: 'Мои игры',
  createBattle: 'Создать игру',
  countPlansPointed: '{totalPointed} of {totalPlans} stories pointed',
  myBattlesError: 'Ошибка поиска ваших игр',
  warriorJoined: '{name} присоединился к игре',
  warriorRetreated: '{name} покинул игру',
  planSkipped: 'Story skipped',
  warriorVoted: '{name} проголосовал',
  warriorRetractedVote: '{name} убрал оценку',
  battleDeleted: 'Game deleted',
  warriorNudgeMessage: 'Хей... {name}, ждем твоего голоса.',
  battle: 'Игра',
  warriors: 'Players',
  battleSocketReconnecting: 'Ooops reloading Game...',
  battleSocketError: 'Error joining game refresh and try again.',
  battleLoading: 'Loading Game...',
  votingNotStarted: 'Голосование еще не началось',
  password: 'Password',
  passwordPlaceholder: 'Enter a password',
  yourPasswordPlaceholder: 'Enter your password',
  confirmPassword: 'Confirm Password',
  confirmPasswordPlaceholder: 'Confirm your password',
  update: 'Update',
  reset: 'Reset',
  passwordResetError: 'Error encountered attempting to reset password',
  resetPassword: 'Reset Password',
  registerAsGuest: 'Register as Guest',
  registrationDisabled: 'Регистрация отключена.',
  userNamePlaceholder: 'Enter your name',
  guestRegisterError: 'Error encountered trying to register as guest',
  registerError: 'Error encountered trying to register account',
  enlistToBattle: 'Enlist to Battle',
  loginForBattle: 'or {loginOpen}Login{loginClose} to join the Game',
  yourNamePlaceholder: 'Enter your name',
  createAccountFormTitle: 'Create an Account {optionalOpen}(optional){optionalClose}',
  sendResetPasswordSuccess: 'Password reset instructions sent to {email}',
  sendResetPasswordError: 'Error encountered attempting to send password reset',
  chooseCountryPlaceholder: 'Choose your country (optional)',
  locale: 'Locale',
  companyPlaceholder: 'Enter your company (optional)',
  jobTitle: 'Job Title',
  jobTitlePlaceholder: 'Enter your job title (optional)',
  enableBattleNotifications: 'Enable game notifications',
  avatar: 'Avatar',
  updateProfile: 'Update Profile',
  guestUsers: 'Guest Users',
  maintenance: 'Maintenance',
  cleanGuests: 'Clean Guests older than {daysOld} days',
  cleanBattles: 'Clean Games older than {daysOld} days',
  chooseLocalePlaceholder: 'Choose your preferred locale (optional)',
  importPlans: 'Import Stories',
  selectFile: 'Select file...',
  theme: 'Theme',
  assignees: 'Assignees',
  assigneeSelectPlaceholder: 'Select an assignee to add',
  assigneeAdd: 'Add Assignee',
  allStoryWithCount: 'All ({count})',
  userUpdate: 'Update User',
  userUpdateSuccess: 'Successfully updated user.',
  userUpdateError: 'Error updating user.',
  invites: 'Invites',
  userInvites: 'User Invites',
  userInviteSent: 'User invite sent',
  userInviteConfirmDelete: 'Are you sure you want to delete this user invite?',
  userInviteDelete: 'Delete Invite',
  acceptInvite: 'Accept Invite',
  rejectInvite: 'Reject Invite',
  rejectingInvite: 'Rejecting...',
  inviteRejected: 'Invite rejected',
  inviteRejectError: 'Error rejecting invite',
  getUserInvitesError: 'Error getting user invites',
  expireDate: 'Expire Date',
  addUserWillInviteNotFoundFieldNote:
    'If user is not registered an invite to register and join the {pageType} will be sent.',
  inviteUserFieldNote: 'An invite to join the {pageType} will be sent.',
  requiresOrganizationMember: 'User must already be in Organization.',
  teamUpdateSuccess: 'Team updated successfully',
  teamUpdateError: 'Error updating Team',
  orgUpdateSuccess: 'Organization updated successfully',
  orgUpdateError: 'Error updating Organization',
  deptUpdateSuccess: 'Department updated successfully',
  deptUpdateError: 'Error updating Department',
  hideVoterIdentity: 'Hide Voter Identity',
  storyboardName: 'Storyboard Name',
  storyboardNamePlaceholder: 'Enter a storyboard name',
  retroPhaseTimeLimitMinLabel: 'Brainstorm Phase time limit in minutes',
  phaseAutoAdvanceLabel: 'Automatically advance phases',
  removeOnlyFacilitatorError: "Can't remove the only facilitator",
  noGamesFound: 'No games found, try creating one.',
  noRetrosFound: 'No retros found, try creating one.',
  noStoryboardsFound: 'No storyboards found, try creating one.',
  retroDescription:
    'A sprint retrospective is a review conducted after a sprint that plays a key role in the Agile methodology. A sprint retrospective aims to determine what went well and where you had problems and identify areas where you can improve.',
  pokerDescription:
    'Scrum poker, also known as “planning poker” and “pointing poker”, is a gamified technique that development teams use to guess the effort of project management tasks. These estimations are based on the entire group’s input and consensus, making them more engaging and accurate than other methods.',
  storyboardDescription:
    'User story mapping (storyboard) is a visualization of the journey a customer takes with a product, from beginning to end. It includes all the tasks they’d typically complete as part of that journey.',
  estimationScaleNamePlaceholder: 'Enter scale name',
  description: 'Description',
  estimationScaleDescriptionPlaceholder: 'Enter scale description',
  scaleType: 'Scale Type',
  estimationScaleTypePlaceholder: 'Select scale type',
  scaleValues: 'Scale Values',
  estimationScaleValuesPlaceholder: 'Enter comma-separated values',
  estimationScaleValuesHelp: 'Enter values separated by commas (e.g., 1, 2, 3, 5, 8)',
  estimationScaleIsPublic: 'Make this scale public',
  estimationScaleDefault: 'Set as default scale',
  estimationScaleSave: 'Save Scale',
  estimationScales: 'Estimation Scales',
  estimationScaleCreate: 'Create Estimation Scale',
  estimationScaleCreateSuccess: 'Estimation scale successfully created',
  estimationScaleCreateError: 'Error creating estimation scale',
  estimationScaleUpdateSuccess: 'Estimation scale successfully updated',
  estimationScaleUpdateError: 'Error updating estimation scale',
  estimationScaleRemoveSuccess: 'Estimation scale successfully removed',
  estimationScaleRemoveError: 'Error removing estimation scale',
  removeEstimationScaleConfirmText: 'Are you sure you want to remove this estimation scale?',
  removeEstimationScale: 'Remove Estimation Scale',
  yes: 'Yes',
  no: 'No',
  isPublic: 'Public',
  default: 'Default',
  publicEstimationScales: 'Public Estimation Scales',
  organizationEstimationScales: 'Organization Estimation Scales',
  teamEstimationScales: 'Team Estimation Scales',
  allowCumulativeVotingLabel: 'Allow Cumulative Voting (more than 1 vote per item group)',
  activeSubscriptions: 'Active Subscriptions',
  retroTemplates: 'Retro Templates',
  publicRetroTemplates: 'Public Retro Templates',
  organizationRetroTemplates: 'Organization Retro Templates',
  teamRetroTemplates: 'Team Retro Templates',
  retroTemplateNamePlaceholder: 'Enter template name',
  retroTemplateDescriptionPlaceholder: 'Enter template description',
  format: 'Format',
  retroTemplateIsPublic: 'Make this template public',
  retroTemplateSave: 'Save Template',
  retroTemplateCreate: 'Create Retrospective Template',
  retroTemplateCreateSuccess: 'Retrospective template successfully created',
  retroTemplateCreateError: 'Error creating retrospective template',
  retroTemplateUpdateSuccess: 'Retrospective template successfully updated',
  retroTemplateUpdateError: 'Error updating retrospective template',
  retroTemplateRemoveSuccess: 'Retrospective template successfully removed',
  retroTemplateRemoveError: 'Error removing retrospective template',
  removeRetroTemplateConfirmText: 'Are you sure you want to remove this retrospective template?',
  removeRetroTemplate: 'Remove Retrospective Template',
  retroTemplateDefault: 'Set as default template',
  jiradatacenterLabel: 'Jira DataCenter',
  loginWithSSO: 'Войти через {provider}',
  requestEmailChangeSuccess:
    'Запрос на изменение электронной почты отправлен, проверьте свой почтовый ящик для получения инструкций',
  requestEmailChangeError: 'Ошибка при попытке изменить электронную почту',
  changeEmail: 'Изменить электронную почту',
  errorChangingEmail:
    'Ошибка при попытке изменить электронную почту, возможно, эта ссылка истекла или уже была использована.',
  emailChanged: 'Электронная почта успешно изменена',
  newEmailToLogin: 'Отныне используйте новую электронную почту для входа.',
  newEmail: 'Новая электронная почта',
  enterYourNewEmail: 'Введите новую электронную почту',
  retroSettings: 'Retro Settings',
  enterFacilitatorCode: 'Enter the Facilitator Code',
  // Modal ariaLabels
  modalCreateAlert: 'Создать оповещение',
  modalUpdateEstimationScale: 'Обновить шкалу оценки',
  modalDeleteConfirmation: 'Подтверждение удаления',
  modalCreateEstimationScale: 'Создать шкалу оценки',
  modalTeamCheckin: 'Проверка команды',
  modalAddPokerStory: 'Добавить историю покера',
  modalCreateUser: 'Создать пользователя',
  modalCreateApiKey: 'Создать ключ API',
  modalImportPokerStories: 'Импортировать истории покера',
  modalSetupMultifactorAuth: 'Настроить многофакторную аутентификацию',
  modalEditPokerGame: 'Редактировать игру покера',
  modalCreateJiraInstance: 'Создать экземпляр Jira',
  modalUpdatePokerSettings: 'Обновить настройки покера',
  modalAddStoryboardGoal: 'Добавить цель сториборда',
  modalViewPokerStory: 'Просмотреть историю покера',
  imageViewer: 'Image viewer',
  imageZoomIn: 'Zoom in',
  imageZoomOut: 'Zoom out',
  imageZoomReset: 'Reset zoom',
  imagePrevious: 'Previous image',
  imageNext: 'Next image',
  imageOpenOriginal: 'Open original image',
  imageCounter: '{current} of {total}',
  storyContentLoading: 'Loading the description and comments from Acelerato...',
  storyContentLoginRequired: 'Sign in to aceleraweb to see the up-to-date description and comments from Acelerato.',
  storyContentLogin: 'Sign in to aceleraweb',
  storyContentError: 'Could not load the up-to-date description. Showing the summary saved in the game.',
  storyComments: 'Comments',
  storyNoComments: 'No comments.',
  modalStoryboardColumnSettings: 'Настройки столбца сториборда',
  modalEditStoryboard: 'Редактировать сториборд',
  modalStoryboardColorLegend: 'Цветовая легенда сториборда',
  modalStoryboardPersonas: 'Персоны сториборда',
  modalRetroActionComments: 'Комментарии действий ретро',
  modalStoryboardStory: 'История сториборда',
  modalTeamAddUser: 'Добавить пользователя в команду',
  modalCreateDepartment: 'Создать отдел',
  modalCreateTeam: 'Создать команду',
  modalCreateOrganization: 'Создать организацию',
  modalCreateRetroTemplate: 'Создать шаблон ретро',
  modalViewRetroTemplateFormat: 'Просмотреть формат шаблона ретро',
  modalUpdateRetroTemplate: 'Обновить шаблон ретро',
  modalAssociateTeamToSubscription: 'Связать команду с подпиской',
  modalAssociateOrganizationToSubscription: 'Связать организацию с подпиской',
  modalTeamUpdateUser: 'Обновить пользователя команды',
  modalSubscriptionForm: 'Форма подписки',
  modalEditRetro: 'Редактировать ретро',
  modalEditRetroActionItem: 'Редактировать элемент действия ретро',
  modalRetroItemComments: 'Комментарии элемента ретро',
  modalUpdateRetroSettings: 'Обновить настройки ретро',
  githubRepository: 'Репозиторий GitHub',
  projects: 'Проекты',
  projectCreate: 'Создать проект',
  projectKey: 'Ключ проекта',
  scope: 'Область',
  createdAt: 'Создано',
  projectRemoveSuccess: 'Проект успешно удален',
  projectRemoveError: 'Ошибка удаления проекта',
  removeProjectConfirmText: 'Вы уверены, что хотите удалить этот проект? Это действие нельзя отменить.',
  removeProject: 'Удалить проект',
  modalCreateProject: 'Создать Проект',
  modalUpdateProject: 'Обновить Проект',
  projectKeyPlaceholder: 'Введите ключ проекта (напр. PROJ)',
  projectNamePlaceholder: 'Введите название проекта',
  projectDescriptionPlaceholder: 'Введите описание проекта (необязательно)',
  projectKeyValidationError: 'Ключ проекта должен содержать 2-10 буквенно-цифровых символов',
  projectKeyHelp: '2-10 символов, только буквы и цифры',
  projectScope: 'Область Проекта',
  projectUpdate: 'Обновить Проект',
  projectCreateSuccess: 'Проект успешно создан',
  projectUpdateSuccess: 'Проект успешно обновлен',
  projectCreateError: 'Не удалось создать проект',
  projectUpdateError: 'Не удалось обновить проект',
  project: 'Проект',
  gameSettings: 'Настройки игры',
  endGame: 'Завершить игру',
  endGameReason: 'Причина завершения игры',
  endGameReasonPlaceholder: 'Выберите причину',
  welcomeBack: 'С возвращением,',
  dashboardSubtitle: 'Сделайте вашу следующую командную сессию по сотрудничеству самой лучшей.',
  filterByTeam: 'Фильтровать по команде:',
  allTeams: 'Все команды',
  showContentForAllTeams: 'Показать содержимое всех команд',
  clearFilter: 'Сбросить фильтр',
  teamPage: 'Страница команды',
  dashboardTeamsRequired: 'Выберите команду, чтобы увидеть ваши сессии planning poker, ретроспективы и storyboards.',
  planningPokerSessions: 'Сессии Planning Poker',
  viewAllPokerSessions: 'Посмотреть все сессии planning poker',
  totalPokerSessions: '{total} сессий всего',
  noSessionsFoundForTeam: 'Сессии не найдены для {teamName}',
  noSessionsFound: 'Сессии не найдены',
  trySelectingDifferentTeamForPoker: 'Попробуйте выбрать другую команду или создать новую игру',
  startFirstPlanningPokerSession: 'Начните свою первую сессию planning poker',
  sprintRetrospectives: 'Ретроспективы спринта',
  viewAllRetros: 'Посмотреть все ретроспективы',
  totalRetros: '{total} ретроспектив всего',
  noRetrosFoundForTeam: 'Ретроспективы не найдены для {teamName}',
  startFirstSprintRetrospective: 'Начните свою первую ретроспективу спринта',
  trySelectingDifferentTeamForRetros: 'Попробуйте выбрать другую команду или создать новую ретроспективу',
  viewAllStoryboards: 'Посмотреть все storyboards',
  totalStoryboards: '{total} storyboards всего',
  noStoryboardsFoundForTeam: 'Storyboards не найдены для {teamName}',
  startFirstStoryboard: 'Начните свой первый storyboard',
  agileStoryMapping: 'Agile Story Mapping',
  trySelectingDifferentTeamForStoryboards: 'Попробуйте выбрать другую команду или создать новый storyboard',
  supportTickets: 'Тикеты поддержки',
  supportTicketDeleteConfirmation: 'Вы уверены, что хотите удалить этот тикет поддержки? Это действие нельзя отменить.',
  supportTicketDelete: 'Удалить тикет',
  updateSupportTicketSuccess: 'Тикет поддержки успешно обновлен',
  updateSupportTicketError: 'Не удалось обновить тикет поддержки',
  getSupportTicketsError: 'Не удалось получить тикеты поддержки',
  deleteSupportTicketSuccess: 'Тикет поддержки успешно удален',
  deleteSupportTicketError: 'Не удалось удалить тикет поддержки',
  clear: 'Очистить',
};

export default ru;
